// Library import
import axios from 'axios';

// File Import
import {apiEndPoints} from './apiEndPoints';

export class PostApi {
    // Create new post
    static createPost(payload) {
        const customConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                Accept: 'application/json'
            }
        };
        return axios.post(apiEndPoints.POST.CREATE_POST, payload, customConfig);
    }

    // Delete a post
    static deletePost(postId, postType) {
        return axios.delete(apiEndPoints.POST.DELETE_POST(postId, postType));
    }

    // Update a post
    static updatePost(postId, payload) {
        return axios.post(apiEndPoints.POST.UPDATE_POST(postId), payload);
    }

    // Upload image
    static uploadImage(payload) {
        return axios.post(apiEndPoints.POST.UPLOAD_IMAGE, payload);
    }

    // Copy image
    static copyImage(payload) {
        return axios.post(apiEndPoints.POST.COPY_IMAGE, payload);
    }

    // Destroy image
    static destroyImage(payload) {
        return axios.post(apiEndPoints.POST.DESTROY_IMAGE, payload);
    }
}
